const SITE_URL = "https://www.kinitech.com.co";

const DEFAULT_META = {
  title: "KINITECH | Soluciones corporativas en tecnología",
  description:
    "KINITECH, tu aliado en Cali: outsourcing de impresión, suministros HP originales, ciberseguridad y desarrollo de software para empresas.",
};

const PAGE_META = {
  "/impresion/outsourcing": {
    title:
      "Outsourcing y alquiler de impresoras HP en Cali | KINITECH",
    description:
      "Outsourcing e impresión en Cali: alquiler de impresoras HP, suministros originales, soporte técnico y gestión de impresión para empresas.",
  },
  "/impresion/consumibles": {
    title: "Suministros HP originales e impresión en Cali | KINITECH",
    description:
      "Suministros HP originales en Cali: tóner y cartuchos originales para impresoras HP empresariales. Canal autorizado HP con asesoría y abastecimiento.",
  },
  "/impresion/papercut": {
    title: "PaperCut: gestión y control de impresión | KINITECH",
    description:
      "Controla, audita y reduce los costos de impresión de tu empresa con PaperCut, la herramienta de gestión de impresión.",
  },
  "/impresion/kpax": {
    title: "KPAX: gestión de dispositivos de impresión | KINITECH",
    description:
      "Monitorea tus dispositivos de impresión, consumibles y contadores en tiempo real con KPAX.",
  },
  "/ciberseguridad/vrx": {
    title: "VRX: gestión de vulnerabilidades | KINITECH",
    description:
      "Herramienta preventiva de gestión de vulnerabilidades para identificar y corregir riesgos en la infraestructura de tu empresa.",
  },
  "/ciberseguridad/sophos": {
    title: "Sophos: seguridad para empresas | KINITECH",
    description:
      "Soluciones de ciberseguridad Sophos para proteger los equipos, la red y la información de tu empresa.",
  },
  "/ciberseguridad/serv-ciberseguridad": {
    title: "Servicios ofensivos de ciberseguridad | KINITECH",
    description:
      "Servicios ofensivos de ciberseguridad para evaluar y fortalecer la seguridad de tu organización.",
  },
  "/outsourcing/desarrollo-soft": {
    title: "Desarrollo de software a la medida | KINITECH",
    description:
      "Desarrollo de software a la medida para optimizar los procesos de tu empresa.",
  },
  "/pages/landing-pages/about-us": {
    title: "Nosotros | KINITECH",
    description: DEFAULT_META.description,
  },
  "/pages/landing-pages/contact-us": {
    title: "Contacto | KINITECH",
    description:
      "Contáctanos para conocer nuestras soluciones de impresión, ciberseguridad y desarrollo de software.",
  },
};

function setMetaTag(selector, attributes, content) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) =>
      tag.setAttribute(key, value),
    );
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function applyPageMeta(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  const { title, description } = PAGE_META[path] || DEFAULT_META;

  document.title = title;
  setMetaTag('meta[name="description"]', { name: "description" }, description);
  setMetaTag('meta[property="og:title"]', { property: "og:title" }, title);
  setMetaTag(
    'meta[property="og:description"]',
    { property: "og:description" },
    description,
  );
  const url = `${SITE_URL}${path}`;
  setMetaTag('meta[property="og:url"]', { property: "og:url" }, url);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);
}
